export default __webpack_public_path__ + "static/media/shapePink.adcac944.svg";